export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const COLLAPSE_MENU = 'COLLAPSE_MENU';
export const COLLAPSE_TOGGLE = 'COLLAPSE_TOGGLE';
export const LAYOUT_TYPE = 'LAYOUT_TYPE';
export const NAV_COLLAPSE_LEAVE = 'NAV_COLLAPSE_LEAVE';
export const NAV_CONTENT_LEAVE = 'NAV_CONTENT_LEAVE';
export const RESET = 'RESET';

export const SIGN_IN = "SIGN_IN"
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS"

export const ADD_RESEARCH = "ADD_RESEARCH"
export const GET_ALL_RESEARCH = "GET_ALL_RESEARCH"
export const GET_ALL_RESEARCH_SUCCESS = "GET_ALL_RESEARCH_SUCCESS"
export const DELETE_RESEARCH = "DELETE_RESEARCH"
export const EDIT_RESEARCH = "EDIT_RESEARCH"
export const DELETE_RESEARCH_GALLERY_IMAGE = "DELETE_RESEARCH_GALLERY_IMAGE"
export const UPDATE_RESEARCH_STATUS_IMAGE = "UPDATE_RESEARCH_STATUS_IMAGE"

export const LOADING_START = "LOADING_START"
export const LOADING_END = "LOADING_END"

export const ADD_PROJECT = "ADD_PROJECT"
export const GET_ALL_PROJECT = "GET_ALL_PROJECT"
export const GET_ALL_PROJECT_SUCCESS = "GET_ALL_PROJECT_SUCCESS"
export const DELETE_PROJECT = "DELETE_PROJECT"
export const EDIT_PROJECT = "EDIT_PROJECT"
export const ADD_UPCOMMING_PROJECT = "ADD_UPCOMMING_PROJECT"

export const ADD_EVENT = "ADD_EVENT"
export const GET_ALL_EVENT = "GET_ALL_EVENT"
export const GET_ALL_EVENT_SUCCESS = "GET_ALL_EVENT_SUCCESS"
export const DELETE_EVENT = "DELETE_EVENT"
export const EDIT_EVENT = "EDIT_EVENT"
export const DELETE_EVENT_IMAGE = "DELETE_EVENT_IMAGE"
export const UPDATE_EVENT_STATUS = "UPDATE_EVENT_STATUS"

export const GET_ALL_TEAM_TYPE = "GET_ALL_TEAM_TYPE"
export const GET_ALL_TEAM_TYPE_SUCCESS = "GET_ALL_TEAM_TYPE_SUCCESS"
export const ADD_TEAM_TYPE = "ADD_TEAM_TYPE"
export const DELETE_TEAM_TYPE = "DELETE_TEAM_TYPE"

export const ADD_TEAM_MEMBER = "ADD_TEAM_MEMBER"
export const GET_ALL_TEAM_MEMBER = "GET_ALL_TEAM_MEMBER"
export const GET_ALL_TEAM_MEMBER_SUCCESS = "GET_ALL_TEAM_MEMBER_SUCCESS"
export const DELETE_TEAM_MEMBER = "DELETE_TEAM_MEMBER"
export const EDIT_TEAM_MEMBER = "EDIT_TEAM_MEMBER"
export const UPDATE_TEAM_MEMBER_STATUS = "UPDATE_TEAM_MEMBER_STATUS"

export const ADD_COLLABORATION = "ADD_COLLABORATION"
export const GET_ALL_COLLABORATION = "GET_ALL_COLLABORATION"
export const GET_ALL_COLLABORATION_SUCCESS = "GET_ALL_COLLABORATION_SUCCESS"
export const DELETE_COLLABORATION = "DELETE_COLLABORATION"
export const EDIT_COLLABORATION = "EDIT_COLLABORATION"
export const UPDATE_COLLABORATION_STATUS = "UPDATE_COLLABORATION_STATUS"

export const ADD_KR = "ADD_KR"
export const GET_ALL_KR = "GET_ALL_KR"
export const GET_ALL_KR_SUCCESS = "GET_ALL_KR_SUCCESS"
export const DELETE_KR = "DELETE_KR"
export const EDIT_KR = "EDIT_KR"
export const UPDATE_KR_STATUS = "UPDATE_KR_STATUS"

export const ADD_BANNER = "ADD_BANNER"
export const GET_ALL_BANNER = "GET_ALL_BANNER"
export const GET_ALL_BANNER_SUCCESS = "GET_ALL_BANNER_SUCCESS"
export const DELETE_BANNER = "DELETE_BANNER"
export const EDIT_BANNER = "EDIT_BANNER"
export const UPDATE_BANNER_STATUS = "UPDATE_BANNER_STATUS"

export const ADD_TRAINING_CATEGORY = "ADD_TRAINING_CATEGORY"
export const GET_ALL_TRAINING_CATEGORY = "GET_ALL_TRAINING_CATEGORY"
export const GET_ALL_TRAINING_CATEGORY_SUCCESS = "GET_ALL_TRAINING_CATEGORY_SUCCESS"
export const DELETE_TRAINING_CATEGORY = "DELETE_TRAINING_CATEGORY"

export const ADD_TRAINING = "ADD_TRAINING"
export const GET_ALL_TRAINING = "GET_ALL_TRAINING"
export const GET_ALL_TRAINING_SUCCESS = "GET_ALL_TRAINING_SUCCESS"
export const DELETE_TRAINING = "DELETE_TRAINING"
export const EDIT_TRAINING = "EDIT_TRAINING"
export const UPDATE_TRAINING_STATUS = "UPDATE_TRAINING_STATUS"
export const DELETE_TRAINING_PDF = "DELETE_TRAINING_PDF"

export const ADD_VACANCIES = "ADD_VACANCIES"
export const GET_ALL_VACANCIES = "GET_ALL_VACANCIES"
export const GET_ALL_VACANCIES_SUCCESS = "GET_ALL_VACANCIES_SUCCESS"
export const EDIT_VACANCIES = "EDIT_VACANCIES"
export const DELETE_VACANCIES = "DELETE_VACANCIES"
export const UPDATE_VACANCIES_STATUS = "UPDATE_VACANCIES_STATUS"

export const ADD_ANNOUNCEMENT = "ADD_ANNOUNCEMENT"
export const GET_ALL_ANNOUNCEMENT = "GET_ALL_ANNOUNCEMENT"
export const GET_ALL_ANNOUNCEMENT_SUCCESS = "GET_ALL_ANNOUNCEMENT_SUCCESS"
export const EDIT_ANNOUNCEMENT = "EDIT_ANNOUNCEMENT"
export const DELETE_ANNOUNCEMENT = "DELETE_ANNOUNCEMENT"
export const UPDATE_ANNOUNCEMENT_STATUS = "UPDATE_ANNOUNCEMENT_STATUS"
